<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ L.localize('Templates_Breadcrumb_Index') }}</h2>
    </header>

    <list
      class="view__content"
      :data="entries()"
      :fields="headers()"
      :hideCreate="false"

      @action="action" />
  </article>
</template>

<script>
import List from 'components/layout/list'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import listHelpers from 'mixins/list-helpers'

export default {
  name: 'templates',
  components: { List },
  mixins: [ listHelpers ],
  beforeCreate() {
    this.$store.dispatch('getAllTemplates')
  },
  data() {
    return {
      L: L
    }
  },
  computed: {
    ...mapGetters({
      templates: 'allTemplates',
      pagination: 'allTemplatesPagination'
    })
  },
  methods: {
    headers: function() {
      let headers = [
        { prop: 'name', label: 'name' }
      ]
      return headers
    },
    entries: function() {
      return this.templates
    },
    action(command) {
      switch (command.name) {
        case 'detail':
          this.$router.push({name: 'template', params: { id: command.item.id }})
          break;
        case 'create':
          this.$router.push({name: 'template-create'})
          break;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Templates.vue?6d407142